const featuresPay = {
    featureTitle: 'データに基づいたビジネス判断を行う',
    featureDescription:
        'どの商品が売れていて最も利益を生んでいるかを把握し、いつでもどこでも財務レポートにアクセスできます。ビジネスを手のひらに！',
    featureButton: "プレミアムサブスクリプション",
    featureStartingPrice: '80',
    featureEndingPart: '30',
    featureStaringText: '開始価格',
    featureEndingText: '千円',

    features: [
        {
            title: '無制限の商品登録',
            description: '所有しているすべての商品を制限なく追加できます。'
        },
        {
            title: '無制限のスタッフ登録',
            description: 'ビジネスにスタッフや管理者を制限なく追加できます。'
        },
        {
            title: '無制限の履歴閲覧',
            description: '古い在庫記録の変更を制限なく確認できます。'
        },
        {
            title: '履歴フィルター',
            description: '種類、カテゴリー、スタッフ、日付ごとに簡単に履歴を確認できます。'
        },
        {
            title: 'Excelにダウンロード',
            description: 'ワンクリックで在庫履歴をMicrosoft Excelにダウンロードできます。'
        },
        {
            title: 'PDFにダウンロード',
            description: 'ワンクリックで最新の商品と在庫リストをPDFにダウンロードできます。'
        }
    ],
    warehousesGuide: [
        {
            desc: '在庫管理を向上させるために複数の倉庫を作成します。'
        },
        {
            desc: '製品を特定の場所に割り当てます。'
        },
        {
            desc: '倉庫全体の在庫レベルを監視します。'
        }
    ],
    addVariantsGuide: [
        { desc: 'サイズ、色、素材のバリエーションを追加します。' },
        { desc: 'バリエーションごとに在庫レベルを設定します。' },
        { desc: '倉庫全体で追跡します。' }
    ]
}

export default featuresPay;
